import React from 'react';
import Logo from './Logo';
import Navigation from './Navigation';
import '../styles/Header.css';
import { useNavigate } from 'react-router-dom';

const Header = ({ isScrolled }) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate('/');
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo-container" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
          <Logo isScrolled={isScrolled}/>
        </div>
        <Navigation />
      </div>
    </header>
  );
};

export default Header;
